// extracted by mini-css-extract-plugin
module.exports = {"container":"event-card-skeleton_container__zGZ1J","text":"event-card-skeleton_text__cMePG","header":"event-card-skeleton_header__P6gaw"};